module.exports = __webpack_public_path__ + "static/media/checkitoff-macbook-calendar.d0ae70ac.jpg";